// extracted by mini-css-extract-plugin
module.exports = {"containerPhrase":"_11qyjBWt","containerLanguage":"_3Pvvvd-4","containerMetaData":"_3vCpX511","labelDescription":"_263alNHw","listTranslations":"_1AR2lsGF"};